/**
 * Page Compositions for Case Associates Lp Theme
 * 
 * Extends the base landing-page theme pages with Case Associates Lp customizations.
 */

import { pages as basePages } from '@vibesites/theme-landing-page/pages';
import type { PageComposition } from '@vibesites/runtime';

/**
 * Case Associates Lp page overrides.
 * Can customize section order, add/remove sections, or change props.
 */
const pageOverrides: Partial<Record<string, PageComposition>> = {
  // Add page overrides here
};

/**
 * Final merged pages for Case Associates Lp properties.
 */
export const pages: Record<string, PageComposition> = {
  ...basePages,
  ...pageOverrides,
};

export default pages;
